export function formatDateYMD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export function formatDateShort(date: Date, language: string): string {
    return date.toLocaleDateString(language.startsWith("en") ? "en-US" : "nb-NO", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
    });
}
